// Age brackets of the user profile (backend users.age_range, codes checked
// by ai.dreamboy.api.utils.UserAgeRange). Coarse on purpose and always
// answerable: no birth date, and "prefer not to say" is a valid answer.
export interface AgeRangeOption {
  value: string;
  labelKey: string;
}

export const AGE_RANGE_OPTIONS: AgeRangeOption[] = [
  { value: '18-24', labelKey: 'age_range.18_24' },
  { value: '25-34', labelKey: 'age_range.25_34' },
  { value: '35-44', labelKey: 'age_range.35_44' },
  { value: '45-54', labelKey: 'age_range.45_54' },
  { value: '55+', labelKey: 'age_range.55_plus' },
  { value: 'prefer_not_to_say', labelKey: 'age_range.prefer_not' },
];

export const ageRangeLabelKey = (value: string | null | undefined): string | null =>
  AGE_RANGE_OPTIONS.find((o) => o.value === value)?.labelKey ?? null;
